// src/api/useSignUp.js
import { useMutation } from "@tanstack/react-query";
import api from "../utils/api";

/**
 * 회원가입을 위한 API 호출 함수
 * @param {Object} userData - 회원가입에 필요한 사용자 데이터 (이메일, 비밀번호 등)
 */
const signUp = (userData) => {
  const { email, password } = userData;

  return api.put("/user/password", {
    email,
    password,
  });
};

/**
 * 회원가입 요청을 위한 useMutation 훅을 사용하는 커스텀 훅
 */
export const useSignUpQuery = () => {
  return useMutation({ mutationFn: signUp });
};
